"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _ConversationThread = _interopRequireDefault(require("./ConversationThread"));

var _ChatComposer = _interopRequireDefault(require("./ChatComposer"));

var _ReasoningTrace = require("./ReasoningTrace");

var _forethoughtApi = require("./forethoughtApi");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GENERIC_FAILURE_MESSAGE = 'The AI assistant is temporarily unavailable. Please try again.';
/**
 * Picks a user-safe message out of an unknown thrown value. ForethoughtApiError
 * is constructed with a generic, status-aware sentence in `forethoughtApi.ts`.
 * Plain Errors (e.g. network failures from fetch itself) are replaced with a
 * generic message so raw HTML / stack traces never reach the chat.
 */

function userFacingError(err) {
  if (err instanceof _forethoughtApi.ForethoughtApiError) {
    return err.message;
  }

  return GENERIC_FAILURE_MESSAGE;
}

function generateId() {
  return "".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 8));
}

function isEscalation(components) {
  return components.some(function (c) {
    return c.type === 'zendesk_handoff' || c.type === 'salesforce_handoff' || c.type === 'zendesk_ticket_creation';
  });
}

var ForethoughtAgentCard = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ForethoughtAgentCard, _PureComponent);

  var _super = _createSuper(ForethoughtAgentCard);

  function ForethoughtAgentCard() {
    var _this;

    (0, _classCallCheck2.default)(this, ForethoughtAgentCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      conversationId: null,
      turns: [],
      isLoading: false,
      isEscalated: false,
      error: null,
      impressionTracked: false,
      contentVisibleAt: null,
      readTimeTimerId: null,
      resultsVisible: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isMountedFlag", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "readTimeInitiated", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "readTimeObserver", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resultsObserver", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "bodyRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastInitiatedQuery", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "inFlight", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "abortController", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchSubmit", function (e) {
      if (e.key !== 'Enter') return;
      var target = e.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'search') return;
      if (!target.closest('.instant-search-wrapper')) return;
      var query = target.value.trim();
      if (!query) return;
      if (query === _this.lastInitiatedQuery) return;
      _this.lastInitiatedQuery = query;
      void _this.startNewConversation(query);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchClear", function (e) {
      var target = e.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'search') return;
      if (!target.closest('.search-box-wrapper')) return;
      if (target.value.trim() !== '') return;

      _this.resetConversation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchClearClick", function (e) {
      if (!(e.target instanceof Element)) return;
      var icon = e.target.closest('.post-icon-wrapper');
      if (!icon) return;
      if (!icon.closest('.search-box-wrapper')) return;

      _this.resetConversation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackForethoughtEvent", function (eventType, elementName) {
      var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Swallow errors here so click handlers that call this (e.g.
      // `handleFollowUpPill`, `handleShowAllResultsClick`) never crash the UI
      // if the underlying tracker fails. Logged for debugging, never surfaced.
      try {
        var _ref, _ForethoughtAgentCard;

        var searchQuery = (_ref = (_ForethoughtAgentCard = ForethoughtAgentCard.readUrlQuery()) !== null && _ForethoughtAgentCard !== void 0 ? _ForethoughtAgentCard : _this.lastInitiatedQuery) !== null && _ref !== void 0 ? _ref : '';

        _publish.default.trackEvent('userevent', _objectSpread({
          type: eventType,
          boundedContext: 'Search',
          entity: 'forethought-ai-answers',
          elementName: elementName,
          eventDetail: "search.forethought-ai-answers.".concat(elementName),
          trackType: 'click',
          searchQuery: searchQuery
        }, extraProps));
      } catch (err) {
        console.warn('[Forethought] trackEvent failed:', err);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackImpression", function (reason) {
      if (_this.state.impressionTracked) return;
      var extraProps = {
        trackType: 'impression',
        impressionReason: reason
      };

      if (reason === 'read_time' && _this.state.contentVisibleAt !== null) {
        extraProps.readTimeSeconds = Math.round((Date.now() - _this.state.contentVisibleAt) / 1000).toString();
      }

      _this.trackForethoughtEvent('Forethought Impression', 'forethoughtImpression', extraProps);

      _this.setState({
        impressionTracked: true
      }); // Interaction-driven impressions short-circuit the read-time timer — no
      // point running it once we already counted the impression.


      if (reason !== 'read_time') {
        _this.clearReadTimeTimer();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleComposerSend", function (query) {
      _this.trackForethoughtEvent('Forethought Follow Up Clicked', 'forethoughtFollowUpClicked', {
        followUpQuery: query
      });

      _this.trackImpression('composer_submit');

      void _this.sendFollowUp(query);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFollowUpPill", function (suggestion) {
      _this.trackForethoughtEvent('Forethought Follow Up Clicked', 'forethoughtFollowUpClicked', {
        followUpQuery: suggestion
      });

      _this.trackImpression('follow_up_click');

      void _this.sendFollowUp(suggestion);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleShowAllResultsClick", function () {
      _this.trackForethoughtEvent('Forethought Show All Results Clicked', 'forethoughtShowAllResultsClicked');

      _this.trackImpression('show_all_results_click');

      var target = document.querySelector('.search-query-info');

      if (target instanceof HTMLElement) {
        target.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSourceArticleClick", function (article) {
      var _article$title, _article$link, _article$source_type;

      _this.trackForethoughtEvent('Forethought Related Article Clicked', 'forethoughtRelatedArticleClicked', {
        articleTitle: (_article$title = article.title) !== null && _article$title !== void 0 ? _article$title : '',
        articleUrl: (_article$link = article.link) !== null && _article$link !== void 0 ? _article$link : '',
        articleSourceType: (_article$source_type = article.source_type) !== null && _article$source_type !== void 0 ? _article$source_type : ''
      });

      _this.trackImpression('related_article_click');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleContentArticleClick", function (e) {
      var _anchor$textContent, _anchor$href;

      var target = e.target;
      if (!(target instanceof Element)) return;
      var anchor = target.closest('.forethought-agent__related-articles a');
      if (!anchor) return;

      _this.trackForethoughtEvent('Forethought Content Article Clicked', 'forethoughtContentArticleClicked', {
        articleTitle: ((_anchor$textContent = anchor.textContent) !== null && _anchor$textContent !== void 0 ? _anchor$textContent : '').trim(),
        articleUrl: (_anchor$href = anchor.href) !== null && _anchor$href !== void 0 ? _anchor$href : ''
      });

      _this.trackImpression('content_article_click');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleButtonSelect", function (outputVariable, value, displayName) {
      _this.appendTurn({
        id: generateId(),
        role: 'user',
        content: displayName,
        components: [],
        timestamp: Date.now()
      });

      void _this.sendFollowUp('', (0, _defineProperty2.default)({}, outputVariable, value));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFormSubmit", function (values) {
      var labels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var summary = Object.entries(values).filter(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            v = _ref3[1];

        return v;
      }).map(function (_ref4) {
        var _labels$k;

        var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
            k = _ref5[0],
            v = _ref5[1];

        return "".concat((_labels$k = labels[k]) !== null && _labels$k !== void 0 ? _labels$k : k, ": ").concat(v);
      }).join(', ');

      if (summary) {
        _this.appendTurn({
          id: generateId(),
          role: 'user',
          content: summary,
          components: [],
          timestamp: Date.now()
        });
      }

      void _this.sendFollowUp('', values);
    });
    return _this;
  }

  (0, _createClass2.default)(ForethoughtAgentCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$bodyRef$current;

      this.isMountedFlag = true; // Initial load: if the URL already has ?q=..., kick off a conversation once.
      // We read the URL directly (not searchState.query) because searchState.query updates
      // on every keystroke via the debounced SearchBox, which would cause a new conversation
      // per character typed.

      var urlQuery = ForethoughtAgentCard.readUrlQuery();

      if (urlQuery) {
        this.lastInitiatedQuery = urlQuery;
        void this.startNewConversation(urlQuery);
      } // Subsequent submits: fire when the user presses Enter inside the search input.


      document.addEventListener('keydown', this.handleSearchSubmit, true); // Reset the agent state whenever the user clears the search box.
      // - `input` catches keyboard-driven clearing (backspace, select+delete, etc.)
      //   because those fire native input events.
      // - `click` catches the X icon in `SearchInputWithIcons`, which clears the
      //   value by writing `input.current.value = ''` directly. Programmatic
      //   value writes don't fire input events, so we have to watch the icon
      //   click separately.

      document.addEventListener('input', this.handleSearchClear, true);
      document.addEventListener('click', this.handleSearchClearClick, true); // Delegated click listener for inline article-link lists. Attached to the
      // scrollable body (rather than the document) so it auto-cleans with the
      // ref and so we don't intercept clicks elsewhere on the page.

      (_this$bodyRef$current = this.bodyRef.current) === null || _this$bodyRef$current === void 0 ? void 0 : _this$bodyRef$current.addEventListener('click', this.handleContentArticleClick);
      this.setupResultsVisibilityObserver();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$bodyRef$current2, _this$abortController;

      this.isMountedFlag = false;
      document.removeEventListener('keydown', this.handleSearchSubmit, true);
      document.removeEventListener('input', this.handleSearchClear, true);
      document.removeEventListener('click', this.handleSearchClearClick, true);
      (_this$bodyRef$current2 = this.bodyRef.current) === null || _this$bodyRef$current2 === void 0 ? void 0 : _this$bodyRef$current2.removeEventListener('click', this.handleContentArticleClick);
      this.cleanupReadTimeTracking();

      if (this.resultsObserver) {
        this.resultsObserver.disconnect();
        this.resultsObserver = null;
      }

      (_this$abortController = this.abortController) === null || _this$abortController === void 0 ? void 0 : _this$abortController.abort();
      this.abortController = null;
    } // No `componentDidUpdate` scroll choreography. The component intentionally
    // never moves the page on its own — agent replies, new user turns, and
    // typing-indicator transitions all render in place and the user stays in
    // control of their viewport. The "Show all results" pill provides the one
    // explicit scroll affordance for users who want to jump past the agent.

  }, {
    key: "cancelInFlight",
    value: function cancelInFlight() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    }
  }, {
    key: "resetConversation",
    value:
    /**
     * Wipes the conversation and any in-flight request. No-op when there's
     * nothing to reset, so this can be called from broad event handlers without
     * burning a needless render on every keystroke.
     */
    function resetConversation() {
      var _this$state = this.state,
          turns = _this$state.turns,
          conversationId = _this$state.conversationId,
          isLoading = _this$state.isLoading,
          error = _this$state.error;

      if (turns.length === 0 && conversationId === null && !isLoading && !error) {
        return;
      }

      this.cancelInFlight();
      this.lastInitiatedQuery = null;
      this.cleanupReadTimeTracking();
      this.setState({
        conversationId: null,
        turns: [],
        isLoading: false,
        isEscalated: false,
        error: null,
        impressionTracked: false,
        contentVisibleAt: null,
        readTimeTimerId: null
      });
    }
    /**
     * Keyboard-driven clearing (backspace, select+delete) — the native `input`
     * event fires on the search input, and we reset once the value is empty.
     */

  }, {
    key: "appendTurn",
    value: function appendTurn(turn) {
      this.setState(function (prev) {
        return {
          turns: [].concat((0, _toConsumableArray2.default)(prev.turns), [turn])
        };
      });
    }
    /**
     * @param kind 'answer' = response to the initial query (POST /conversation).
     *             'reply'  = response to a follow-up (PUT /conversation/{id}).
     *             Drives whether we emit `forethoughtAnswerGeneration` (one per
     *             conversation, signals "AI replaced a search result") or
     *             `forethoughtReplyGeneration` (per follow-up turn, signals
     *             "user kept chatting"). Separating the two lets analytics
     *             distinguish first-touch usage from ongoing engagement.
     */

  }, {
    key: "appendAgentResponse",
    value: function appendAgentResponse(response, responseTimeMs, kind) {
      var _response$widget_comp, _response$widget_comp2;

      var turn = {
        id: generateId(),
        role: 'agent',
        content: '',
        components: (_response$widget_comp = response.widget_components) !== null && _response$widget_comp !== void 0 ? _response$widget_comp : [],
        timestamp: Date.now(),
        responseTimeMs: responseTimeMs,
        articles: (0, _ReasoningTrace.extractArticlesFromComponents)((_response$widget_comp2 = response.widget_components) !== null && _response$widget_comp2 !== void 0 ? _response$widget_comp2 : []),
        reasoning: response.reasoning
      };
      this.setState(function (prev) {
        return {
          turns: [].concat((0, _toConsumableArray2.default)(prev.turns), [turn]),
          conversationId: response.conversation_id || prev.conversationId,
          isEscalated: prev.isEscalated || isEscalation(turn.components)
        };
      }); // Telemetry is wrapped so a tracker failure (e.g. consent gating, network
      // hiccup, IntersectionObserver unavailable) never propagates to the
      // outer API try/catch — that catch is for actual conversation failures.
      // Without this guard a thrown tracker call would set `state.error` to the
      // generic "temporarily unavailable" message even though the agent
      // response had already rendered successfully.

      try {
        if (kind === 'answer') {
          this.trackForethoughtEvent('Forethought Answer Generation', 'forethoughtAnswerGeneration', {
            trackType: 'generation',
            responseTimeMs: String(responseTimeMs)
          }); // The first agent response has now rendered — start the 10s read-time
          // observer so the impression fires from passive viewing if the user
          // doesn't click anything. Interaction-triggered impressions short-circuit
          // the timer (see `trackImpression`).

          this.setupReadTimeTracking();
        } else {
          this.trackForethoughtEvent('Forethought Reply Generation', 'forethoughtReplyGeneration', {
            trackType: 'generation',
            responseTimeMs: String(responseTimeMs)
          });
        }
      } catch (telemetryErr) {
        console.warn('[Forethought] telemetry failed:', telemetryErr);
      }
    }
    /**
     * Mirrors `SmartSummary#trackAIAnswersEvent`. Centralized so every event
     * we emit from the agent (generations, clicks, follow-ups, impressions)
     * shares the same shape and the same `boundedContext` / `entity` pair.
     * Analytics dashboards then partition Forethought-vs-AI-Answers via the
     * `entity` field alone.
     */

  }, {
    key: "setupReadTimeTracking",
    value:
    /**
     * Sets up the 10s-visible IntersectionObserver. Called after the first agent
     * response renders (so the observer has real content to watch). Mirrors the
     * SmartSummary pattern: threshold 0.5, fires once, then disconnects.
     */
    function setupReadTimeTracking() {
      var _this2 = this;

      if (this.readTimeInitiated) return;
      var target = this.bodyRef.current;
      if (!target || typeof IntersectionObserver === 'undefined') return;

      try {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (_this2.readTimeInitiated) return;
            _this2.readTimeInitiated = true;
            var visibleAt = Date.now();
            var timerId = window.setTimeout(function () {
              if (!_this2.isMountedFlag) return;

              _this2.trackImpression('read_time');
            }, 10000);

            _this2.setState({
              contentVisibleAt: visibleAt,
              readTimeTimerId: timerId
            });

            observer.disconnect();
          });
        }, {
          threshold: 0.5
        });
        observer.observe(target);
        this.readTimeObserver = observer;
      } catch (err) {
        console.warn('[Forethought] read-time observer setup failed:', err);
      }
    }
    /**
     * Observes `.instant-search__results-wrapper` (rendered by `InstantSearch`
     * below the agent) and flips `state.resultsVisible` whenever it crosses the
     * viewport boundary. The "Show all results" button uses this flag to hide
     * itself once the user has reached the results — leaving it on-screen at
     * that point is redundant noise.
     *
     * The results wrapper is rendered by a sibling component, so we
     * `querySelector` for it from the document instead of holding a ref. Safe
     * because the selector is stable (it's the established class name used by
     * the "Show all results" click handler as well).
     *
     * Retries with `requestAnimationFrame` once if the element isn't in the DOM
     * yet at mount time — InstantSearch streams its layout in around the same
     * tick the agent mounts, and on slow renders the element can be a frame
     * behind us.
     */

  }, {
    key: "setupResultsVisibilityObserver",
    value: function setupResultsVisibilityObserver() {
      var _this3 = this;

      var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (typeof IntersectionObserver === 'undefined') return;
      var target = document.querySelector('.instant-search__results-wrapper');

      if (!target) {
        if (retry) {
          requestAnimationFrame(function () {
            return _this3.setupResultsVisibilityObserver(false);
          });
        }

        return;
      }

      try {
        this.resultsObserver = new IntersectionObserver(function (entries) {
          var visible = entries.some(function (e) {
            return e.isIntersecting;
          });
          if (!_this3.isMountedFlag) return;
          if (_this3.state.resultsVisible === visible) return;

          _this3.setState({
            resultsVisible: visible
          });
        }, // Any sliver of the wrapper showing counts as "visible" — the goal is
        // to hide the button the moment the user has reached the section, not
        // to wait until half of it is on-screen.
        {
          threshold: 0
        });
        this.resultsObserver.observe(target);
      } catch (err) {
        console.warn('[Forethought] results visibility observer setup failed:', err);
      }
    }
  }, {
    key: "clearReadTimeTimer",
    value: function clearReadTimeTimer() {
      if (this.state.readTimeTimerId !== null) {
        window.clearTimeout(this.state.readTimeTimerId);

        if (this.isMountedFlag) {
          this.setState({
            readTimeTimerId: null
          });
        }
      }
    }
  }, {
    key: "cleanupReadTimeTracking",
    value: function cleanupReadTimeTracking() {
      this.readTimeInitiated = false;
      this.clearReadTimeTimer();

      if (this.readTimeObserver) {
        this.readTimeObserver.disconnect();
        this.readTimeObserver = null;
      }

      if (this.isMountedFlag) {
        this.setState({
          contentVisibleAt: null
        });
      }
    }
  }, {
    key: "startNewConversation",
    value: function () {
      var _startNewConversation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(query) {
        var signal, _yield$startConversat, data, responseTimeMs;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // A new query supersedes any pending request — cancel it so its eventual response
                // doesn't get appended after we've already moved on.
                this.cancelInFlight();
                this.abortController = new AbortController();
                signal = this.abortController.signal; // New conversation = new impression window. Tear down any active observer
                // / pending read-time timer from the prior conversation so the next first
                // response can re-arm them cleanly.

                this.cleanupReadTimeTracking();
                this.setState({
                  conversationId: null,
                  turns: [],
                  isLoading: true,
                  isEscalated: false,
                  error: null,
                  impressionTracked: false,
                  contentVisibleAt: null,
                  readTimeTimerId: null
                });
                this.inFlight = true;
                _context.prev = 6;
                _context.next = 9;
                return (0, _forethoughtApi.startConversation)(query, signal);

              case 9:
                _yield$startConversat = _context.sent;
                data = _yield$startConversat.data;
                responseTimeMs = _yield$startConversat.responseTimeMs;
                this.appendAgentResponse(data, responseTimeMs, 'answer');
                this.setState({
                  isLoading: false
                });
                _context.next = 23;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](6);

                if (!signal.aborted) {
                  _context.next = 20;
                  break;
                }

                return _context.abrupt("return");

              case 20:
                console.error('[Forethought] startConversation failed:', _context.t0); // Allow retrying the same query after an error.

                this.lastInitiatedQuery = null;
                this.setState({
                  isLoading: false,
                  error: userFacingError(_context.t0)
                });

              case 23:
                _context.prev = 23;
                this.inFlight = false;
                return _context.finish(23);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 16, 23, 26]]);
      }));

      function startNewConversation(_x) {
        return _startNewConversation.apply(this, arguments);
      }

      return startNewConversation;
    }()
  }, {
    key: "sendFollowUp",
    value: function () {
      var _sendFollowUp = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(query) {
        var contextVariables,
            conversationId,
            signal,
            _yield$continueConver,
            data,
            responseTimeMs,
            status,
            isConversationGone,
            _args2 = arguments;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                contextVariables = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                if (!this.inFlight) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                conversationId = this.state.conversationId;

                if (conversationId) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return this.startNewConversation(query);

              case 7:
                return _context2.abrupt("return");

              case 8:
                // Follow-ups also get an abort handle so unmount mid-flight doesn't strand the request.
                this.cancelInFlight();
                this.abortController = new AbortController();
                signal = this.abortController.signal;

                if (query) {
                  this.appendTurn({
                    id: generateId(),
                    role: 'user',
                    content: query,
                    components: [],
                    timestamp: Date.now()
                  });
                }

                this.setState({
                  isLoading: true,
                  error: null
                });
                this.inFlight = true;
                _context2.prev = 14;
                _context2.next = 17;
                return (0, _forethoughtApi.continueConversation)(conversationId, query || null, contextVariables, signal);

              case 17:
                _yield$continueConver = _context2.sent;
                data = _yield$continueConver.data;
                responseTimeMs = _yield$continueConver.responseTimeMs;
                this.appendAgentResponse(data, responseTimeMs, 'reply');
                this.setState({
                  isLoading: false
                });
                _context2.next = 38;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](14);

                if (!signal.aborted) {
                  _context2.next = 28;
                  break;
                }

                return _context2.abrupt("return");

              case 28:
                console.error('[Forethought] continueConversation failed:', _context2.t0); // 400/404 on continue means the upstream conversation has expired or no longer
                // exists (Solve drops sessions after ~1h of inactivity). When we still have the
                // user's query, transparently retry it as a fresh conversation so the user
                // doesn't need to resubmit. For empty-query continue calls (button clicks /
                // form submits with no free-text input) we can't synthesize a new POST start,
                // so surface a clear "send again" prompt instead.

                status = _context2.t0 instanceof _forethoughtApi.ForethoughtApiError ? _context2.t0.status : undefined;
                isConversationGone = status === 400 || status === 404;

                if (!(isConversationGone && query)) {
                  _context2.next = 37;
                  break;
                }

                // Reset state so startNewConversation builds a clean thread. We drop the
                // stale user turn we appended above because startNewConversation will
                // append its own.
                this.inFlight = false;
                this.setState({
                  conversationId: null,
                  turns: [],
                  error: null
                });
                _context2.next = 36;
                return this.startNewConversation(query);

              case 36:
                return _context2.abrupt("return");

              case 37:
                this.setState(function (prevState) {
                  return {
                    conversationId: isConversationGone ? null : prevState.conversationId,
                    isLoading: false,
                    error: isConversationGone ? 'That conversation expired. Send your message again to continue.' : userFacingError(_context2.t0)
                  };
                });

              case 38:
                _context2.prev = 38;
                this.inFlight = false;
                return _context2.finish(38);

              case 41:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[14, 24, 38, 41]]);
      }));

      function sendFollowUp(_x2) {
        return _sendFollowUp.apply(this, arguments);
      }

      return sendFollowUp;
    }() // Enter-driven submit from the in-conversation `ChatComposer`. Counted as a
    // follow-up the same way an explicit pill tap is — same event type, same
    // shape — so analytics doesn't have to special-case keyboard vs. mouse.

  }, {
    key: "render",
    value: function render() {
      var hidden = this.props.hidden;
      var _this$state2 = this.state,
          turns = _this$state2.turns,
          isLoading = _this$state2.isLoading,
          error = _this$state2.error,
          isEscalated = _this$state2.isEscalated,
          resultsVisible = _this$state2.resultsVisible; // `--active` enables the fixed-height + scrollable-body layout. Gated on
      // the presence of at least one turn (i.e. the first real response has
      // arrived) — during the initial loading state we want the panel to stay
      // compact around the typing indicator instead of jumping to a 700px box
      // before there's any content to put in it. After the first reply lands,
      // follow-ups keep `--active` on because the turn list isn't empty.

      var isActive = turns.length > 0;
      var wrapperClass = "forethought-agent".concat(isActive ? ' forethought-agent--active' : '');
      return (0, _preact.h)("div", {
        className: wrapperClass,
        hidden: hidden
      }, (0, _preact.h)("div", {
        className: "forethought-agent__body",
        ref: this.bodyRef
      }, (0, _preact.h)("div", {
        className: "forethought-agent__header"
      }, (0, _preact.h)("div", {
        className: "forethought-agent__identity"
      }, (0, _preact.h)("div", {
        className: "forethought-agent__avatar"
      }, (0, _preact.h)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true"
      }, (0, _preact.h)("circle", {
        cx: "9",
        cy: "9.5",
        r: "3",
        fill: "white"
      }), (0, _preact.h)("circle", {
        cx: "16",
        cy: "10.5",
        r: "2.4",
        fill: "white"
      }), (0, _preact.h)("path", {
        d: "M3 19c.6-2.8 3-4.8 6-4.8s5.4 2 6 4.8",
        stroke: "white",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        fill: "none"
      }), (0, _preact.h)("path", {
        d: "M14 17.5c.5-2 2.2-3.4 4.2-3.4s3.7 1.4 4.2 3.4",
        stroke: "white",
        strokeWidth: "1.4",
        strokeLinecap: "round",
        fill: "none"
      }))), (0, _preact.h)("div", {
        className: "forethought-agent__identity-text"
      }, (0, _preact.h)("span", {
        className: "forethought-agent__name"
      }, "Community Agent"), (0, _preact.h)("span", {
        className: "forethought-agent__subtitle"
      }, "Usually resolves in 30 seconds"))), (0, _preact.h)("div", {
        className: "forethought-agent__powered-by"
      }, (0, _preact.h)("span", {
        className: "forethought-agent__powered-by-label"
      }, "Powered by"), (0, _preact.h)("svg", {
        className: "forethought-agent__powered-by-logo",
        width: "146",
        height: "24",
        viewBox: "0 0 146 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Forethought AI Agents by Zendesk"
      }, (0, _preact.h)("g", {
        clipPath: "url(#forethought-logo-clip)"
      }, (0, _preact.h)("path", {
        d: "M12.7276 3.20001H6.44515C4.98837 3.20001 3.80473 4.38366 3.80473 5.84044V6.91025H2.7349C1.27811 6.86476 0.0489392 8.00289 0.00113823 9.45964C-0.0443865 10.9164 1.09373 12.1456 2.55052 12.1912H3.80245V14.308H2.73262C1.27583 14.308 0.0921873 15.4917 0.0921873 16.9485V20.6587C0.0921873 22.1155 1.27583 23.2992 2.73262 23.2992C4.18941 23.2992 5.37305 22.1155 5.37305 20.6587V15.8786H10.1532C11.61 15.8331 12.748 14.6039 12.7025 13.1472C12.657 11.7587 11.5416 10.6661 10.1532 10.6205H5.37305V8.45809H12.7253C14.1821 8.45809 15.3657 7.27447 15.3657 5.81767C15.3657 4.36089 14.1844 3.20001 12.7276 3.20001ZM3.80473 20.6587C3.80473 21.2506 3.32672 21.7286 2.7349 21.7286C2.14307 21.7286 1.66507 21.2506 1.66507 20.6587V16.9485C1.66507 16.3567 2.14307 15.8786 2.7349 15.8786H3.80473V20.6587ZM11.1342 13.3292C11.0887 13.8528 10.679 14.2625 10.1554 14.308H5.37534V12.1912H10.1554C10.7473 12.2367 11.1797 12.7375 11.1342 13.3292ZM2.7349 10.6205C2.14307 10.6205 1.66507 10.1425 1.66507 9.55073C1.66507 8.95889 2.14307 8.48087 2.7349 8.48087H3.80473V10.6205H2.7349ZM12.7276 6.88753H5.37534V5.84044C5.37534 5.24863 5.85331 4.77061 6.44515 4.77061H12.7276C13.3194 4.81614 13.7518 5.31691 13.7064 5.90876C13.6608 6.43228 13.2511 6.84199 12.7276 6.88753Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M52.4655 19.4818C52.3756 18.902 52.0298 18.4752 51.3382 18.4752C50.6954 18.4752 50.2501 18.8408 50.1313 19.4818H52.4655ZM51.4464 21.211C51.9905 21.211 52.3861 20.9871 52.6236 20.7527L53.2078 21.3833C52.8209 21.7803 52.2874 22.0751 51.4569 22.0751C50.0326 22.0751 49.1122 21.1296 49.1122 19.8474C49.1122 18.5766 50.0824 17.6207 51.3277 17.6207C52.7415 17.6207 53.5433 18.6982 53.4739 20.1938H50.1313C50.2501 20.8139 50.6849 21.211 51.4464 21.211Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.8226 21.1354L32.3171 18.5467H29.8231V17.7291H33.4724V18.5633L30.9437 21.1702H33.5376V21.987H29.8272L29.8226 21.1354Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M37.3701 19.4818C37.2802 18.902 36.9343 18.4752 36.2417 18.4752C35.5988 18.4752 35.1543 18.8408 35.0354 19.4818H37.3701ZM36.3509 21.211C36.895 21.211 37.2906 20.9871 37.5282 20.7527L38.1117 21.3833C37.7256 21.7803 37.1919 22.0751 36.3613 22.0751C34.9359 22.0751 34.0162 21.1296 34.0162 19.8474C34.0162 18.5766 34.9865 17.6207 36.232 17.6207C37.6461 17.6207 38.4479 18.6982 38.3781 20.1938H35.0354C35.1543 20.8139 35.5892 21.211 36.3509 21.211Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M47.5336 19.8341C47.5336 19.0704 46.9565 18.4437 46.1725 18.4437C45.406 18.4437 44.8114 19.0529 44.8114 19.8341C44.8114 20.6153 45.406 21.2342 46.1725 21.2342C46.9565 21.2342 47.5336 20.6065 47.5336 19.8341ZM43.8984 19.8429C43.8984 18.4692 44.9227 17.6099 46.0523 17.6099C46.6207 17.6099 47.1635 17.8591 47.4819 18.2542V15.7209H48.3948V22.0095H47.4819V21.3965C47.1547 21.8179 46.6119 22.075 46.0435 22.075C44.9499 22.075 43.8984 21.2078 43.8984 19.8429Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M53.8691 21.0829L54.7006 20.6555C54.9353 21.0489 55.3166 21.2796 55.811 21.2796C56.3305 21.2796 56.5998 21.0148 56.5998 20.7159C56.5998 20.3732 56.0969 20.2963 55.5507 20.1853C54.8137 20.0314 54.0649 19.792 54.0649 18.9117C54.0649 18.2361 54.7006 17.612 55.7246 17.6208C56.5299 17.6208 57.1278 17.9363 57.4665 18.4493L56.6942 18.8689C56.4958 18.5691 56.1577 18.3812 55.7246 18.3812C55.2302 18.3812 54.9785 18.6207 54.9785 18.8943C54.9785 19.2019 55.3774 19.2876 56.0014 19.424C56.7129 19.5778 57.5145 19.8097 57.5145 20.6994C57.5145 21.2895 56.9987 22.0837 55.7667 22.075C54.8654 22.075 54.2329 21.7157 53.8691 21.0829Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M59.9897 20.0941L59.2782 20.8785V21.987H58.3657V15.7639H59.2718L59.2777 19.8388L61.2003 17.7291H62.2755L60.6307 19.5487L62.3406 21.987H61.2979L59.9897 20.0941Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.1941 17.6636C40.1127 17.6636 39.207 18.3586 39.207 19.5111V21.987H40.1193V19.6226C40.1193 18.9267 40.5367 18.5146 41.2238 18.5146C41.9101 18.5146 42.2698 18.9306 42.2698 19.6264V21.987H43.1821V19.5111C43.1821 18.3586 42.2755 17.6636 41.1941 17.6636Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M23.8775 19.9C23.8775 21.2343 23.109 22.1041 21.969 22.1041C21.2512 22.1041 20.6686 21.7325 20.3814 21.0992V22.0196H19.917V15.7283H20.3814V18.7346C20.6517 18.0929 21.2512 17.6875 21.9775 17.6875C23.1259 17.6875 23.8775 18.5658 23.8775 19.9ZM23.413 19.9C23.413 18.8022 22.8557 18.1013 21.9015 18.1013C20.9641 18.1013 20.3814 18.8191 20.3814 19.9C20.3814 20.9978 20.9557 21.6903 21.9015 21.6903C22.8557 21.6903 23.413 20.9978 23.413 19.9Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M25.0869 23.624L25.8638 21.7578L24.1918 17.7719H24.69L26.1172 21.2342L27.5105 17.7719H27.9919L25.5598 23.624H25.0869Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M19.8005 13.262H21.5396V9.72384H24.8179V8.14464H21.5396V6.02571H25.4576V4.44653H19.8005V13.262Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M30.5948 7.24541C30.095 6.96552 29.5353 6.82562 28.8757 6.82562C28.216 6.82562 27.6762 6.96552 27.1765 7.24541C26.6768 7.52525 26.2969 7.92504 26.0171 8.40482C25.7373 8.9045 25.5974 9.46429 25.5974 10.1239C25.5974 10.7836 25.7373 11.3433 26.0171 11.8431C26.2969 12.3427 26.6968 12.7226 27.1965 13.0024C27.6962 13.2823 28.2559 13.4223 28.8956 13.4223C29.5353 13.4223 30.095 13.2823 30.5948 13.0024C31.0945 12.7226 31.4743 12.3228 31.7542 11.8431C32.0341 11.3633 32.1739 10.7836 32.1739 10.1239C32.1739 9.46429 32.0341 8.9045 31.7542 8.40482C31.4743 7.90504 31.0945 7.52525 30.5948 7.24541ZM30.2749 11.0235C30.135 11.2833 29.9551 11.5032 29.7352 11.6432C29.4953 11.8031 29.2354 11.8631 28.9156 11.8631C28.5958 11.8631 28.3359 11.7831 28.076 11.6432C27.8361 11.4832 27.6362 11.2833 27.5163 11.0235C27.3764 10.7636 27.3165 10.4638 27.3165 10.1039C27.3165 9.74408 27.3764 9.46424 27.5163 9.1844C27.6562 8.9245 27.8361 8.70461 28.076 8.56472C28.3159 8.40482 28.5958 8.34482 28.8956 8.34482C29.1955 8.34482 29.4753 8.42477 29.7152 8.56472C29.9551 8.72461 30.135 8.9245 30.2749 9.1844C30.4149 9.44429 30.4748 9.74408 30.4748 10.1039C30.4748 10.4638 30.4149 10.7436 30.2749 11.0235Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M34.6913 8.10484L34.6713 8.12484V6.96548H33.0122V13.2623H34.6713V9.94393C34.6713 9.62409 34.7713 9.34425 34.9912 9.14436C35.211 8.94446 35.4709 8.78452 35.8107 8.68457C36.1506 8.58462 36.5104 8.54462 36.9102 8.54462V6.92548C36.4504 6.92548 36.0306 7.02542 35.6108 7.24532C35.251 7.44521 34.9312 7.72505 34.6913 8.10484Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M43.128 8.52476C42.8481 7.96508 42.4683 7.54529 42.0085 7.2454C41.5488 6.94556 41.0291 6.80566 40.4693 6.80566C39.9097 6.80566 39.27 6.94556 38.7702 7.22545C38.2705 7.50529 37.8907 7.90508 37.6108 8.38486C37.3309 8.8846 37.191 9.44433 37.191 10.104C37.191 10.7636 37.3309 11.3233 37.5908 11.8231C37.8707 12.3228 38.2305 12.7026 38.7103 12.9825C39.19 13.2624 39.7298 13.4023 40.3694 13.4023C41.0091 13.4023 41.3089 13.3423 41.6888 13.2024C42.0685 13.0625 42.4083 12.8825 42.6882 12.6227C42.9681 12.3628 43.208 12.063 43.3679 11.7032L41.8887 11.1234C41.7687 11.3633 41.6088 11.5432 41.3889 11.7032C41.169 11.8431 40.8891 11.9231 40.5493 11.9231C40.2095 11.9231 39.9896 11.8631 39.7497 11.7431C39.5099 11.6232 39.31 11.4433 39.15 11.2234C39.0301 11.0235 38.9501 10.8036 38.9301 10.5637H43.5478C43.5478 9.76417 43.4079 9.08449 43.128 8.52476ZM39.0301 9.32438C39.0501 9.08449 39.13 8.90454 39.25 8.74465C39.4099 8.56476 39.5898 8.42486 39.8097 8.34486C40.0296 8.26486 40.2295 8.22497 40.4293 8.22497C40.6293 8.22497 40.8292 8.26486 41.0291 8.34486C41.229 8.42486 41.4089 8.56476 41.5488 8.74465C41.6688 8.8846 41.7287 9.08449 41.7487 9.32438H39.0301Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M54.1235 7.12519C53.7838 6.9253 53.3438 6.82535 52.8442 6.82535C52.3445 6.82535 51.9447 6.9453 51.5849 7.20514C51.365 7.36509 51.1651 7.56498 51.0052 7.80487V4.46655H49.346V13.2821H51.0052V9.98375C51.0052 9.46402 51.1251 9.06423 51.345 8.78434C51.5849 8.52445 51.9047 8.38455 52.3445 8.38455C52.5844 8.38455 52.7843 8.44455 52.9642 8.54445C53.1441 8.64445 53.284 8.82434 53.3838 9.06423C53.4841 9.30413 53.5438 9.62391 53.5438 10.0637V13.2821H55.203V9.72391C55.203 9.04423 55.1027 8.5045 54.923 8.08471C54.7433 7.66493 54.4633 7.32509 54.1235 7.12519Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M60.9998 7.24541C60.5006 6.96552 59.9411 6.82562 59.2814 6.82562C58.6217 6.82562 58.0814 6.96552 57.5822 7.24541C57.0825 7.52525 56.7022 7.92504 56.4227 8.40482C56.1422 8.9045 56.003 9.46429 56.003 10.1239C56.003 10.7836 56.1422 11.3433 56.4227 11.8431C56.7022 12.3427 57.1022 12.7226 57.6019 13.0024C58.1017 13.2823 58.6617 13.4223 59.3011 13.4223C59.9411 13.4223 60.5006 13.2823 60.9998 13.0024C61.5001 12.7226 61.8793 12.3228 62.1598 11.8431C62.4393 11.3633 62.5795 10.7836 62.5795 10.1239C62.5795 9.46429 62.4393 8.9045 62.1598 8.40482C61.8793 7.90504 61.5001 7.52525 60.9998 7.24541ZM60.6803 11.0235C60.5401 11.2833 60.3603 11.5032 60.1406 11.6432C59.9006 11.8031 59.6409 11.8631 59.3209 11.8631C59.0009 11.8631 58.7411 11.7831 58.4814 11.6432C58.2414 11.4832 58.0419 11.2833 57.9214 11.0235C57.7817 10.7636 57.7214 10.4638 57.7214 10.1039C57.7214 9.74408 57.7817 9.46424 57.9214 9.1844C58.0617 8.9245 58.2414 8.70461 58.4814 8.56472C58.7214 8.40482 59.0009 8.34482 59.3011 8.34482C59.6009 8.34482 59.8803 8.42477 60.1203 8.56472C60.3603 8.72461 60.5401 8.9245 60.6803 9.1844C60.8206 9.44429 60.8803 9.74408 60.8803 10.1039C60.8803 10.4638 60.8206 10.7436 60.6803 11.0235Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M67.5966 10.2638C67.5966 10.7835 67.4766 11.1833 67.2569 11.4632C67.0366 11.743 66.6969 11.863 66.2569 11.863C66.0371 11.863 65.8174 11.803 65.6377 11.703C65.4579 11.6031 65.3177 11.4232 65.2179 11.1833C65.1177 10.9434 65.0777 10.6236 65.0777 10.1838V6.96543H63.419V10.5236C63.419 11.2033 63.5187 11.743 63.6985 12.1628C63.8787 12.5826 64.1385 12.9024 64.4979 13.1023C64.8579 13.3022 65.2777 13.4022 65.7774 13.4022C66.2777 13.4022 66.6766 13.2822 67.0169 13.0224C67.2569 12.8624 67.4366 12.6426 67.6169 12.3827L67.6963 13.2423H69.2558V6.94543H67.5966V10.2638Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M74.9918 7.90508L74.9715 7.94508C74.7923 7.64524 74.5721 7.40534 74.3118 7.20545C73.9523 6.94556 73.5129 6.80566 72.9929 6.80566C72.4734 6.80566 71.9134 6.94556 71.4937 7.20545C71.0739 7.46529 70.7342 7.84513 70.4942 8.32486C70.2542 8.80465 70.1342 9.38433 70.1342 10.024C70.1342 10.6637 70.2542 11.1834 70.4942 11.6432C70.7342 12.1029 71.0542 12.4428 71.4937 12.7026C71.9134 12.9625 72.4131 13.0824 72.9929 13.0824C73.5726 13.0824 73.9326 12.9625 74.3118 12.7026C74.5721 12.5227 74.7923 12.3028 74.9715 12.023V12.6227C74.9715 13.0425 74.8921 13.3823 74.7518 13.6622C74.6121 13.942 74.4121 14.1419 74.1523 14.2619C73.8921 14.4018 73.5923 14.4618 73.2729 14.4618C72.9529 14.4618 72.6131 14.4218 72.3331 14.3618C72.0734 14.3018 71.8334 14.2219 71.6334 14.1419C71.4334 14.062 71.2937 13.982 71.1737 13.902L70.5139 15.2413C70.6739 15.3413 70.8739 15.4612 71.1337 15.5612C71.3934 15.6612 71.6931 15.7611 72.0734 15.8211C72.4334 15.8811 72.8729 15.921 73.3529 15.921C74.0323 15.921 74.6121 15.7811 75.1118 15.5212C75.6115 15.2613 75.9913 14.8815 76.251 14.3618C76.5107 13.8621 76.651 13.2424 76.651 12.5427V6.92561H74.9918V7.90508ZM74.7321 10.8636C74.6121 11.1234 74.4521 11.3233 74.2323 11.4633C74.0126 11.6032 73.7726 11.6832 73.4729 11.6832C73.1726 11.6832 72.9129 11.6032 72.6931 11.4633C72.4531 11.3233 72.2931 11.1234 72.1534 10.8636C72.0334 10.6037 71.9534 10.3239 71.9534 9.98406C71.9534 9.64422 72.0334 9.34433 72.1534 9.10449C72.2734 8.84465 72.4531 8.6647 72.6729 8.50476C72.8931 8.36486 73.1529 8.28486 73.4526 8.28486C73.7523 8.28486 73.9923 8.36486 74.2121 8.50476C74.4323 8.64476 74.5923 8.84465 74.7118 9.10449C74.8323 9.36433 74.8921 9.64422 74.8921 9.98406C74.8921 10.3239 74.8323 10.6037 74.7118 10.8636H74.7321Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M82.6083 7.12519C82.2686 6.9253 81.8286 6.82535 81.3288 6.82535C80.8291 6.82535 80.4296 6.9453 80.0696 7.20514C79.8494 7.36509 79.6494 7.56498 79.4899 7.80487V4.46655H77.8307V13.2821H79.4899V9.98375C79.4899 9.46402 79.6099 9.06423 79.8296 8.78434C80.0696 8.52445 80.3896 8.38455 80.8291 8.38455C81.0691 8.38455 81.2691 8.44455 81.4488 8.54445C81.6286 8.64445 81.7688 8.82434 81.8691 9.06423C81.9688 9.30413 82.0286 9.62391 82.0286 10.0637V13.2821H83.6878V9.72391C83.6878 9.04423 83.5875 8.5045 83.4083 8.08471C83.228 7.66493 82.948 7.32509 82.6083 7.12519Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M117.177 6.81805C117.681 6.81805 118.119 6.95261 118.489 7.22168C118.749 7.40509 118.968 7.64483 119.145 7.94067V6.96941H120.809V12.5949C120.809 13.3013 120.675 13.9066 120.406 14.4112C120.137 14.9241 119.754 15.3109 119.258 15.5716C118.77 15.8322 118.186 15.9626 117.505 15.9626C117.025 15.9626 116.601 15.929 116.231 15.8617C115.861 15.7945 115.55 15.7062 115.297 15.5969C115.046 15.4875 114.839 15.3783 114.68 15.2689L115.335 13.9319C115.453 13.9992 115.609 14.0749 115.802 14.159C115.996 14.2514 116.227 14.3271 116.496 14.386C116.765 14.4533 117.076 14.4869 117.429 14.4869C117.766 14.4869 118.06 14.4197 118.312 14.2851C118.573 14.159 118.775 13.9571 118.918 13.6797C119.069 13.4105 119.145 13.0658 119.145 12.6454V12.0511C118.968 12.3286 118.749 12.5561 118.489 12.7337C118.119 12.9775 117.681 13.0994 117.177 13.0994C116.597 13.0994 116.092 12.9733 115.663 12.7211C115.243 12.4688 114.915 12.1156 114.68 11.6615C114.444 11.2074 114.326 10.6693 114.326 10.0471C114.326 9.39117 114.444 8.82355 114.68 8.34424C114.915 7.85656 115.243 7.48237 115.663 7.22168C116.092 6.95261 116.597 6.81805 117.177 6.81805ZM117.644 8.30643C117.349 8.30643 117.089 8.37789 116.862 8.52088C116.634 8.66381 116.458 8.86141 116.332 9.11363C116.206 9.36589 116.138 9.66024 116.13 9.99661C116.138 10.3246 116.206 10.6189 116.332 10.8796C116.458 11.1318 116.634 11.3336 116.862 11.4849C117.097 11.6279 117.362 11.6994 117.656 11.6994C117.942 11.6994 118.19 11.6279 118.4 11.4849C118.619 11.3336 118.787 11.1318 118.905 10.8796C119.023 10.6189 119.081 10.3246 119.081 9.99661C119.081 9.66024 119.018 9.36589 118.893 9.11363C118.775 8.86141 118.607 8.66381 118.388 8.52088C118.178 8.37789 117.929 8.30643 117.644 8.30643Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M124.957 6.81805C125.512 6.81805 126.021 6.96525 126.483 7.25955C126.954 7.54547 127.328 7.97005 127.606 8.53341C127.892 9.0884 128.034 9.76541 128.034 10.5642H123.412C123.433 10.8134 123.506 11.0362 123.632 11.2327C123.792 11.4597 123.994 11.6363 124.238 11.7624C124.49 11.8801 124.759 11.939 125.045 11.939C125.39 11.939 125.672 11.8675 125.89 11.7246C126.109 11.5732 126.277 11.3798 126.394 11.1443L127.883 11.7246C127.706 12.0777 127.476 12.3847 127.189 12.6454C126.912 12.8976 126.58 13.091 126.193 13.2256C125.806 13.3601 125.365 13.4273 124.869 13.4273C124.246 13.4273 123.696 13.2886 123.216 13.0111C122.737 12.7252 122.359 12.3342 122.081 11.8381C121.812 11.342 121.678 10.7702 121.678 10.1227C121.678 9.47528 121.816 8.90339 122.094 8.40728C122.38 7.91117 122.766 7.52435 123.254 7.24685C123.75 6.96099 124.318 6.81811 124.957 6.81805ZM124.906 8.23069C124.713 8.23069 124.507 8.27277 124.288 8.35683C124.07 8.44093 123.88 8.57549 123.721 8.76045C123.596 8.90653 123.522 9.09576 123.501 9.32808H126.237C126.216 9.09576 126.147 8.90653 126.029 8.76045C125.886 8.57549 125.709 8.44093 125.499 8.35683C125.297 8.27277 125.1 8.23069 124.906 8.23069Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M137.866 6.96939H139.443V8.38209H137.866V11.0688C137.866 11.3378 137.925 11.5438 138.043 11.6868C138.161 11.8213 138.333 11.8885 138.56 11.8885C138.644 11.8885 138.737 11.8717 138.838 11.8381C138.938 11.7961 139.044 11.7372 139.153 11.6615L139.733 12.9102C139.532 13.0616 139.304 13.1835 139.052 13.276C138.808 13.3769 138.565 13.4273 138.32 13.4273C137.623 13.4273 137.093 13.255 136.731 12.9102C136.378 12.5654 136.201 12.0736 136.201 11.4345V8.38209H135.18V6.96939H136.201V5.00171H137.866V6.96939Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M142.982 6.81805C143.377 6.81811 143.743 6.87693 144.079 6.99469C144.424 7.1124 144.718 7.27635 144.962 7.48659C145.206 7.69677 145.374 7.94061 145.467 8.21811L144.092 8.84877C144.033 8.68061 143.89 8.54605 143.663 8.44515C143.436 8.33581 143.209 8.28125 142.982 8.28125C142.755 8.28125 142.579 8.33165 142.452 8.43256C142.334 8.52504 142.276 8.65544 142.276 8.8236C142.276 8.93288 142.334 9.02541 142.452 9.10109C142.57 9.16835 142.738 9.22723 142.957 9.27768L143.776 9.47944C144.189 9.58029 144.517 9.74429 144.76 9.97133C145.013 10.1899 145.193 10.4381 145.303 10.7155C145.421 10.9847 145.479 11.2495 145.479 11.5102C145.479 11.8886 145.366 12.2249 145.139 12.5192C144.92 12.8051 144.617 13.028 144.231 13.1877C143.852 13.3475 143.419 13.4273 142.932 13.4273C142.528 13.4273 142.149 13.3685 141.796 13.2507C141.443 13.1246 141.132 12.9481 140.863 12.7211C140.594 12.4856 140.384 12.1997 140.232 11.8634L141.657 11.2075C141.784 11.4093 141.956 11.5859 142.175 11.7373C142.393 11.8802 142.646 11.9515 142.932 11.9516C143.209 11.9516 143.423 11.9138 143.575 11.8381C143.726 11.7541 143.802 11.6363 143.802 11.4849C143.802 11.3336 143.739 11.2243 143.613 11.157C143.495 11.0814 143.331 11.0183 143.121 10.9679L142.541 10.8165C141.935 10.6567 141.456 10.4044 141.103 10.0597C140.758 9.70648 140.585 9.30285 140.585 8.84877C140.585 8.20131 140.791 7.70104 141.204 7.34787C141.624 6.99469 142.217 6.81805 142.982 6.81805Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M100.129 13.276H98.3006L97.5566 11.3336H93.8979L93.1545 13.276H91.3251L94.8067 4.44678H96.6483L100.129 13.276ZM94.4825 9.80743H96.9726L95.7273 6.55522L94.4825 9.80743Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M102.691 13.276H100.963V4.44678H102.691V13.276Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M132.272 6.81805C132.768 6.81805 133.192 6.91901 133.545 7.12083C133.898 7.32264 134.168 7.63795 134.353 8.0668C134.538 8.48723 134.626 9.03379 134.617 9.70643V13.276H132.953V10.0471C132.953 9.61821 132.902 9.28605 132.801 9.05064C132.709 8.81517 132.574 8.64691 132.398 8.546C132.221 8.43672 132.015 8.38211 131.78 8.38211C131.351 8.37373 131.018 8.50408 130.783 8.77315C130.57 9.02541 130.457 9.39224 130.444 9.87363L130.442 9.97133V13.276H128.778V6.96941H130.342L130.416 7.81923C130.582 7.56333 130.78 7.3556 131.01 7.1964C131.372 6.94419 131.792 6.81811 132.272 6.81805Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M86.8979 6.99665H88.4766V8.41169H86.8979V11.1026C86.8979 11.3721 86.9566 11.5785 87.0745 11.7217C87.1923 11.8564 87.3651 11.9237 87.5923 11.9237C87.6766 11.9237 87.7694 11.9069 87.8702 11.8732C87.9715 11.8312 88.0766 11.7722 88.1865 11.6964L88.7673 12.9471C88.5651 13.0987 88.3379 13.2208 88.0851 13.3134C87.8409 13.4145 87.5966 13.465 87.3523 13.465C86.6537 13.465 86.123 13.2924 85.7603 12.9471C85.4067 12.6018 85.2302 12.1091 85.2302 11.469V8.41169H84.2067V6.99665H85.2302V5.02582H86.8979V6.99665Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        d: "M46.679 6.99665H48.2582V8.41169H46.679V11.1026C46.679 11.3721 46.738 11.5785 46.8559 11.7217C46.9738 11.8564 47.1465 11.9237 47.3738 11.9237C47.458 11.9237 47.5507 11.9069 47.6517 11.8732C47.7528 11.8312 47.8581 11.7722 47.9676 11.6964L48.5487 12.9471C48.3466 13.0987 48.1192 13.2208 47.8666 13.3134C47.6223 13.4145 47.3781 13.465 47.1338 13.465C46.4348 13.465 45.9041 13.2924 45.542 12.9471C45.1882 12.6018 45.0114 12.1091 45.0114 11.469V8.41169H43.9881V6.99665H45.0114V5.02582H46.679V6.99665Z",
        fill: "currentColor"
      }), (0, _preact.h)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114.155 13.276H112.326L111.582 11.3336H107.924L107.18 13.276H105.351L108.832 4.44678H110.673L114.155 13.276ZM108.508 9.80743H110.998L109.753 6.55522L108.508 9.80743Z",
        fill: "currentColor"
      })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
        id: "forethought-logo-clip"
      }, (0, _preact.h)("rect", {
        width: "145.6",
        height: "24",
        fill: "white"
      })))))), (0, _preact.h)("hr", {
        className: "forethought-agent__divider",
        "aria-hidden": "true"
      }), !turns.length && !isLoading && (0, _preact.h)("div", {
        className: "forethought-agent__empty"
      }, "Type your question above and press Enter \u2014 the AI agent will respond here."), (turns.length > 0 || isLoading) && (0, _preact.h)(_ConversationThread.default, {
        turns: turns,
        isLoading: isLoading,
        disabled: isLoading || isEscalated,
        onButtonSelect: this.handleButtonSelect,
        onFormSubmit: this.handleFormSubmit,
        onFollowUpSelect: this.handleFollowUpPill,
        onSourceClick: this.handleSourceArticleClick
      }), error && (0, _preact.h)("div", {
        className: "forethought-agent__error"
      }, error)), turns.length > 0 && !isEscalated && (0, _preact.h)("hr", {
        className: "forethought-agent__divider",
        "aria-hidden": "true"
      }), turns.length > 0 && !isEscalated && (0, _preact.h)(_ChatComposer.default, {
        disabled: isLoading,
        onSend: this.handleComposerSend,
        placeholder: "Ask a follow-up\u2026"
      }), turns.length > 0 && !isEscalated && !resultsVisible && (0, _preact.h)("button", {
        type: "button",
        className: "forethought-agent__show-results",
        onClick: this.handleShowAllResultsClick,
        "aria-label": "Show all search results"
      }, (0, _preact.h)("span", {
        className: "forethought-agent__show-results-label"
      }, "Show all results"), (0, _preact.h)("svg", {
        className: "forethought-agent__show-results-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true"
      }, (0, _preact.h)("path", {
        d: "M5 8l5 5 5-5",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }))));
    }
  }], [{
    key: "readUrlQuery",
    value: function readUrlQuery() {
      if (typeof window === 'undefined') return null;

      try {
        var _URLSearchParams$get;

        var raw = (_URLSearchParams$get = new URLSearchParams(window.location.search).get('q')) === null || _URLSearchParams$get === void 0 ? void 0 : _URLSearchParams$get.trim();
        return raw !== null && raw !== void 0 ? raw : null;
      } catch (_unused) {
        return null;
      }
    }
  }]);
  return ForethoughtAgentCard;
}(_preactCompat.PureComponent);

var _default = ForethoughtAgentCard;
exports.default = _default;